// eslint-disable-next-line import/prefer-default-export
export enum Store {
  default = 'default',
  en = 'nov_en',
  de = 'nov_de',
  fr = 'nov_fr',
  es = 'nov_es',
}
